import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

type PortalDsButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost';

type PortalDsButtonSize = 'sm' | 'md';

const VARIANT_CLASSES: Record<PortalDsButtonVariant, string> = {
  primary: portalDs.btnPrimary,
  accent: portalDs.btnAccent,
  secondary: portalDs.btnSecondary,
  ghost: portalDs.btnGhost,
};

const SIZE_CLASSES: Record<PortalDsButtonSize, string> = {
  sm: portalDs.btnSm,
  md: portalDs.btnMd,
};

export interface PortalDsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: PortalDsButtonVariant;
  size?: PortalDsButtonSize;
}

export function PortalDsButton({
  variant = 'secondary',
  size = 'md',
  className,
  type = 'button',
  ...props
}: PortalDsButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        portalDs.btnBase,
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className,
      )}
      {...props}
    />
  );
}
